import Api from "@/services/Api";

export default {
  createUser(params: object) {
    return Api().post("/users", params);
  },
  getUsers(params: object) {
    return Api().get("/users", { params: params });
  },
  getMyProfile() {
    return Api().get(`/users/me`);
  },
  updateUser(params: object) {
    return Api().put(`/users/me`, params);
  },
  deleteUser(id: number) {
    return Api().delete(`/users/${id}`);
  },
  leaveService() {
    return Api().put(`/users/leave_service`);
  },
  recoverUser(params: object) {
    return Api().post("/users/recover", params);
  },
  getFincodeInfo() {
    return Api().get("/users/get_fincode");
  }
};
